import { AssetsHelper } from '@/helpers/assetsHelper';
import { UserHelper } from '@/helpers/user.helper';
import { Injectable, inject } from '@angular/core';
import { UsersService } from '@eemo/api-client';
import { Subject, take } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { AuthenticationService } from './authentication.service';
import { BridgeInputService } from './bridge/bridge-input.service';
import { BridgeService, UserInfoToNative } from './bridge/bridge.service';
import { NotificationCheckService } from './notification-check.service';

@Injectable({ providedIn: 'root' })
export class AppService {
  private authService = inject(AuthenticationService);
  private userHelper = inject(UserHelper);
  private bridgeInputService = inject(BridgeInputService);
  authenticationService = inject(AuthenticationService);
  private appConfigService = inject(AppConfigService);
  private usersService = inject(UsersService);
  private notificationCheckService = inject(NotificationCheckService);

  wasCreatedProperty$ = new Subject<void>();
  wasDeletedProperty$ = new Subject<void>();

  static getLogo(): string {
    return AssetsHelper.logo;
  }

  initForNative() {
    if (this.appConfigService.isMobileApp) {
      this.bridgeInputService.logout$.subscribe(() => {
        this.authenticationService.logout();
        BridgeService.newMenu([]);
      });

      this.authService.currentUserSubject.subscribe((user) => {
        if (user != null) {
          const userToNative: UserInfoToNative = {
            uid: user.userId,
            displayName: this.userHelper.displayName,
            email: user.email,
            role: user.role,
            accountType: user.accountType,
          };
          BridgeService.userInfo(userToNative);
        }
      });

      this.notificationCheckService.notificationCount.subscribe((count) => BridgeService.notificationsCount(count));
    }
  }

  saveAvatar(userId: string) {
    this.usersService
      .getUserAvatar(userId)
      .pipe(take(1))
      .subscribe((file: Blob) => {
        this.authenticationService.saveCurrentAvatar(file);
      });
  }
}
